module.exports = __webpack_public_path__ + "static/media/disconnect.451f7154.svg";